module.exports = __webpack_public_path__ + "img/wx.d04d680.png";